import { styled } from '@mui/material/styles';
import { Box, Dialog, IconButton } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
    width: '90vw',
    maxWidth: '900px',
    height: '90vh',
    maxHeight: '700px',
    margin: '16px',
    padding: '24px',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  zIndex: 99999999,
}));

export const StepContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  textAlign: 'center',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  paddingBottom: '60px', // Space for navigation
  '& > *:not(:last-child)': {
    flex: '0 0 auto',
  },
  '& > div:has(iframe)': {
    width: '100%',
    height: '0',
    paddingBottom: '35%', // Reduced from 40% to take less vertical space
    position: 'relative',
    maxHeight: '300px', // Reduced from 350px
    marginTop: '-8px', // Reduce gap above video
    marginBottom: '-8px', // Reduce gap below video
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }
  },
}));


export const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '600px',
  height: 'auto',
  maxHeight: '40vh',
  marginBottom: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  '@media (max-width: 600px)': {
    marginBottom: '8px',
    maxHeight: '35vh',
  }
}));

export const NavigationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: 'calc(100% - 48px)', // Account for parent padding
  position: 'absolute',
  bottom: 0,
  left: '24px', // Match parent padding
  right: '24px',
  padding: '16px 0',
  backgroundColor: '#fff',
  zIndex: 1,
}));

export const StepIndicators = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  marginTop: '16px',
}));

export const StepDot = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: active ? theme.palette.primary.main : theme.palette.grey[300],
  transition: 'background-color 0.3s ease',
}));
